export default __webpack_public_path__ + "static/media/CQM Training _ Consultancy.eeb31894.png";